import React from 'react'
import { ButtonWithLoading } from '../FormsyHelperComponent'

export default (props) => {
  return <ButtonWithLoading variant="contained" color="secondary" {...props} />
}
